import { render } from "./OrderHistory.vue?vue&type=template&id=51c18620&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=51c18620&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c18620"]])

export default __exports__